import { applyTheme } from './theme';
import { readCachedTheme } from './store';

// Apply the last-known theme synchronously at startup (before React mounts) so
// there's no flash of the static default. The live theme is fetched from the
// DB shortly after and re-applied by useDesignTheme().
const cached = readCachedTheme();
if (cached) applyTheme(cached);
